import React, { Fragment, useState, useEffect } from "react";
import Topbar from "../layouts/TopBar";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import ConfigResources from "../resources/ConfigResources";
import UserResources from "../resources/UserResources";
import toast from 'react-hot-toast';
import moment from "moment/moment";
import Select from 'react-select';
import { connect } from "react-redux";
import { loginSuccess, logout } from "../redux/actions/LoggedInAction";
import {ACCESS_DENIED} from '../Messages'

function ManageConfig({isLoggedIn, loggedInUser}){

    const [configs, setConfigs] = useState([])
    const [originalConfigs, setOriginalConfigs] = useState([])
    const [users, setUsers] = useState([])
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)

    const configResources = new ConfigResources()
    const userResources = new UserResources()

    const loadConfigs = () => {
        return configResources.get()
    }

    const loadUsers = () => {
        return userResources.get_admin()
    }

    useEffect(() => {
        loadUsers().then(response => {
            if (response.error && response.error.length > 0) {
                toast.error("Failed to load users: " + response.error)
            } else {
                setUsers(response['body'])
            }
        }).catch((err) => {
            toast.error("Network error: " + err)
        })

        loadConfigs().then(response => {
            if (response.error && response.error.length > 0) {
                toast.error("Failed to load configs: " + response.error)
            } else {
                const configData = response['body']
                setConfigs(configData)
                setOriginalConfigs(JSON.parse(JSON.stringify(configData)))
            }
        }).catch((err) => {
            toast.error("Network error: " + err)
        })
    }, [])

    const handleConfigValueChange = (configIndex, newValue) => {
        const updatedConfigs = JSON.parse(JSON.stringify(configs))
        updatedConfigs[configIndex].value = newValue
        setConfigs(updatedConfigs)
        setHasUnsavedChanges(true)
    }

    const handleSaveChanges = () => {
        const savePromises = []

        configs.forEach((config, index) => {
            const original = originalConfigs[index]

            // Check if value has changed
            if (JSON.stringify(config.value) !== JSON.stringify(original.value)) {
                const updateData = {
                    value: config.value,
                    description: config.description
                }
                savePromises.push(configResources.update(config.id, updateData))
            }
        })

        if (savePromises.length === 0) {
            toast("No changes to save")
            return
        }

        Promise.all(savePromises).then((responses) => {
            const hasError = responses.some(response => response.error && response.error.length > 0)
            if (hasError) {
                const errorMessages = responses
                    .filter(response => response.error && response.error.length > 0)
                    .map(response => response.error)
                    .join(', ')
                toast.error("Failed to save configs: " + errorMessages)
            } else {
                toast.success("Configuration saved successfully")
                setOriginalConfigs(JSON.parse(JSON.stringify(configs)))
                setHasUnsavedChanges(false)

                // Reload configs
                loadConfigs().then(response => {
                    if (response.error && response.error.length > 0) {
                        toast.error("Failed to reload configs: " + response.error)
                    } else {
                        const configData = response['body']
                        setConfigs(configData)
                        setOriginalConfigs(JSON.parse(JSON.stringify(configData)))
                    }
                })
            }
        }).catch((err) => {
            toast.error("Failed to save configs: " + err)
        })
    }

    const renderConfigValue = (config, configIndex) => {
        const value = config.value
        const hasUserDetails = config.user_details

        // Check if this config has user_details (meaning it's user IDs)
        if (hasUserDetails) {
            // Map currently selected user IDs to dropdown format
            const selectedUsers = Array.isArray(value)
                ? value.map(userId => {
                    const user = users.find(u => String(u.id) === String(userId))
                    return user ? {
                        value: user.id,
                        label: `${user.firstname} ${user.lastname}`
                    } : null
                }).filter(u => u !== null)
                : [];

            return (
                <Select
                    isMulti
                    value={selectedUsers}
                    onChange={(selectedOptions) => {
                        const userIds = selectedOptions ? selectedOptions.map(opt => opt.value) : []
                        handleConfigValueChange(configIndex, userIds)
                    }}
                    options={users.map(u => ({
                        value: u.id,
                        label: `${u.firstname} ${u.lastname}`
                    }))}
                    classNamePrefix='select-css-tag'
                    placeholder="Select users..."
                    isSearchable={true}
                />
            )
        } else if (Array.isArray(value)) {
            // Non-user array - display as JSON
            return (
                <input
                    type="text"
                    value={JSON.stringify(value)}
                    onChange={(e) => {
                        try {
                            const parsed = JSON.parse(e.target.value)
                            handleConfigValueChange(configIndex, parsed)
                        } catch (err) {
                            // Invalid JSON, don't update
                        }
                    }}
                    style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ccc',
                        borderRadius: '4px'
                    }}
                />
            )
        } else if (typeof value === 'number') {
            // Number value
            return (
                <input
                    type="number"
                    value={value}
                    onChange={(e) => {
                        const numValue = e.target.value === '' ? '' : Number(e.target.value)
                        handleConfigValueChange(configIndex, numValue)
                    }}
                    style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ccc',
                        borderRadius: '4px'
                    }}
                />
            )
        } else {
            // String value
            return (
                <input
                    type="text"
                    value={value}
                    onChange={(e) => {
                        handleConfigValueChange(configIndex, e.target.value)
                    }}
                    style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ccc',
                        borderRadius: '4px'
                    }}
                />
            )
        }
    }


    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                        {(isLoggedIn && loggedInUser['role.name'] === 'admin')?
                            <h1 style={{color:"#ffa800"}} className="block-title"><strong>Manage Configuration</strong></h1>
                                :
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{ACCESS_DENIED}</strong></h1>
                            }

                        </div>
                    </div>
                </div>
            </div>


            <div id="main-container">
                {
                    (isLoggedIn && loggedInUser['role.name'] === 'admin') ?

                <div className="content">
                    <div className="container">
                        <div className="spacer-40"></div>

                        <div style={{
                            padding: '15px',
                            backgroundColor: '#fff3cd',
                            border: '2px solid #dc3545',
                            borderRadius: '5px',
                            marginBottom: '20px'
                        }}>
                            <strong style={{color: '#dc3545', fontSize: '16px'}}>
                                ⚠️ WARNING: For the Configuration changed, when you click save, the new values will COMPLETELY replace existing values.
                            </strong>
                        </div>

                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{width: '20%'}}><strong>Name</strong></TableCell>
                                        <TableCell style={{width: '25%'}}><strong>Description</strong></TableCell>
                                        <TableCell style={{width: '25%'}}><strong>Current Value</strong></TableCell>
                                        <TableCell style={{width: '30%'}}><strong>Edit Value</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {configs.map((config, configIndex) => {
                                        const value = config.value
                                        const userDetails = config.user_details
                                        let displayValue = ''

                                        // Generate display value using user_details if available
                                        if (userDetails) {
                                            if (Array.isArray(userDetails)) {
                                                const userNames = userDetails.map(user => `${user.firstname} ${user.lastname}`)
                                                displayValue = userNames.length > 0 ? userNames.join(', ') : 'None selected'
                                            } else {
                                                displayValue = `${userDetails.firstname} ${userDetails.lastname}`
                                            }
                                        } else if (Array.isArray(value)) {
                                            displayValue = JSON.stringify(value)
                                        } else {
                                            displayValue = value.toString()
                                        }

                                        return (
                                            <TableRow key={config.id}>
                                                <TableCell>
                                                    <strong style={{color: '#003165'}}>{config.name}</strong>
                                                </TableCell>
                                                <TableCell>
                                                    <span style={{color: '#666', fontSize: '14px'}}>
                                                        {config.description || 'No description'}
                                                    </span>
                                                </TableCell>
                                                <TableCell>
                                                    <div style={{
                                                        padding: '8px',
                                                        backgroundColor: '#f8f9fa',
                                                        borderRadius: '4px',
                                                        fontSize: '14px',
                                                        color: '#495057',
                                                        minHeight: '38px',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        {displayValue}
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    {renderConfigValue(config, configIndex)}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {configs.length > 0 && (
                            <div style={{marginTop: '20px', marginBottom: '20px'}}>
                                <button
                                    onClick={handleSaveChanges}
                                    disabled={!hasUnsavedChanges}
                                    style={{
                                        backgroundColor: hasUnsavedChanges ? '#ffa800' : '#ccc',
                                        color: '#fff',
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: hasUnsavedChanges ? 'pointer' : 'not-allowed',
                                        fontSize: '16px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Save Changes
                                </button>
                            </div>
                        )}

                        <div className="spacer-50"></div>
                    </div>
                </div> : <></>
        }
            </div>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageConfig);